<template>
    <div class="app-toggle">
        <label
            class="app-toggle-switch"
            :class="{ checked: newValue }"
            :for="`switch-${id}`"
        >
            <input
                type="checkbox"
                :id="`switch-${id}`"
                v-model="newValue"
                @change="onInput"
            />
            <span class="app-toggle-slide"></span>
        </label>
    </div>
</template>

<script>
export default {
    name: "app-toggle",

    emits: ["update:modelValue", "change"],

    props: {
        modelValue: [String, Number, Boolean],
        id: String,
        disabled: false
    },

    data() {
        return {
            newValue: this.modelValue
        };
    },

    watch: {
        modelValue() {
            this.newValue = this.modelValue;
        }
    },

    methods: {
        onInput() {
            this.$emit("update:modelValue", this.newValue);
            this.$emit("change", this.newValue);
        }
    },

    computed: {}
};
</script>

<style lang="scss" scoped>
.app-toggle {
}
</style>
